import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@indipia/shared';

// 로컬 개발 전용: .env.local의 VITE_DEV_BYPASS_AUTH=true 시 백엔드 없이 미리보기
// 프로덕션 번들에서는 Vite가 이 블록을 dead-code로 제거
if (import.meta.env.VITE_DEV_BYPASS_AUTH === 'true' && !useAuthStore.getState().accessToken) {
  useAuthStore.getState().setAuth({
    accessToken: 'dev-mock-token',
    refreshToken: 'dev-mock-refresh',
    user: { memberId: 1, memberName: '개발자', compId: 1, compName: '테스트회사', masterYn: 'Y' },
  });
}

export function RequireAuth() {
  const token = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
